var $ccd12307ad9f0dfc$exports = {};
$ccd12307ad9f0dfc$exports = {
    "backButton": (args)=>`Nazaj na ${args.prevMenuButton}`,
    "moreActions": `Ve\u{10D} mo\u{17E}nosti`,
    "unavailable": `Ni na voljo, raz\u{161}irite za podrobnosti`
};


export {$ccd12307ad9f0dfc$exports as default};
//# sourceMappingURL=sl-SI.mjs.map
